import { createReducer } from 'redux-act';
import { setPointsTiers, clearPointsTiers } from './pointsConversionActions';

const initialState = {
  name: undefined,
  tiers: [],
};

export const reducer = createReducer(
  {
    [setPointsTiers]: (state, { name, tiers }) => ({ ...state, name, tiers }),
    [clearPointsTiers]: (state) => ({ ...state, name: null, tiers: [] }),
  },
  initialState,
);
